export default {
  config: `/activity/config`,
  log: "/activity/log",
  user: '/activity/user',
  prize: '/activity/prize'
};
